import { useMsal } from "@azure/msal-react";
import { MSALConstants } from "../constants/msal";

function useSignUp () {
    //TODO: Use routes from components module
    const DEFAULT_REDIRECT = "/auth/login";
    const { instance } = useMsal();

    const signupWithRole = (role, callbackUrl) => {
        callbackUrl = callbackUrl || DEFAULT_REDIRECT;

        instance.loginRedirect({
            redirectUri: DEFAULT_REDIRECT,
            redirectStartPage: DEFAULT_REDIRECT,
            authority: MSALConstants.AUTH.CONFIGURATION.SIGNUP_AUTHORITY,
            state: JSON.stringify({
                callbackUrl: callbackUrl,
                userRole: role
            })
          }).catch(e => {
            console.log(e);
          });
    }

    const signIn = (callbackUrl, state) => {
        callbackUrl = callbackUrl || DEFAULT_REDIRECT;
        state = state || null;

        instance.loginRedirect({
            redirectUri: DEFAULT_REDIRECT,
            redirectStartPage: DEFAULT_REDIRECT,
            state: state
          }).catch(e => {
            console.log(e);
          });
    }

    return {
        signupWithRole,
        signIn
    };
}

export default useSignUp;
